import { Flex, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormStateContext,
  useFormValidation,
} from 'ui'
import { type BuyTogetherEffect as BuyTogetherEffectType } from '../../../../typings'
import { BuyTogetherBenefitView } from './Benefit/View'
import { messages } from './messages'
import { BuyTogetherTriggerView } from './Trigger/View'
import { suite } from './validation'

type BuyTogetherProps = {
  name: string
}

export function BuyTogetherEffect(props: BuyTogetherProps) {
  const { form } = useFormStateContext()
  const { name } = props

  const buyTogetherConfig: BuyTogetherEffectType = useWatch({ form, name })

  const triggerName = `${name}.trigger` as const
  const benefitName = `${name}.benefit` as const

  const validationBuyTogether = (v, { intl }) => {
    suite(intl, triggerName, benefitName)(v)
  }

  useFormValidation('buy-together-effect', {
    fieldName: name,
    validateFn: validationBuyTogether,
  })

  const handleChange = (
    config:
      | BuyTogetherEffectType['trigger']
      | BuyTogetherEffectType['benefit']
      | undefined,
    name: typeof triggerName | typeof benefitName
  ) => {
    form.setValue(name, config)
    form.formState.isSubmitted && form.trigger()
  }

  return (
    <Section>
      <SectionHeader>
        <Flex direction="column" align="baseline">
          <SectionTitle>
            <FormattedMessage {...messages.title} />
          </SectionTitle>
          <Text tone="secondary">
            <FormattedMessage {...messages.description} />
          </Text>
        </Flex>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <BuyTogetherTriggerView
          config={buyTogetherConfig}
          onChange={(config) => handleChange(config, triggerName)}
          name={triggerName}
        />
        <BuyTogetherBenefitView
          config={buyTogetherConfig}
          onChange={(config) => handleChange(config, benefitName)}
          name={benefitName}
        />
      </SectionContent>
    </Section>
  )
}
